import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { MyAvailabilityWidget } from "@/features/availability/MyAvailabilityWidget"
import { GlobalSearch } from "./topbar/GlobalSearch"
import { NotificationBell } from "./topbar/NotificationBell"
import { TopbarBreadcrumb } from "./topbar/TopbarBreadcrumb"
import { UserMenu } from "./topbar/UserMenu"

export function AppTopbar() {
  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b bg-background/95 px-4 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <SidebarTrigger />
      <Separator orientation="vertical" className="h-5" />
      <TopbarBreadcrumb />
      <div className="flex flex-1 justify-center px-4">
        <GlobalSearch />
      </div>
      <div className="flex items-center gap-1">
        <MyAvailabilityWidget />
        <NotificationBell />
        <UserMenu />
      </div>
    </header>
  )
}
